export default {
    active: emailstate => emailstate.active,
    emailobj: emailstate => emailstate
}
